var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn btn-xs btn-warning",attrs:{"disabled":_vm.deleter.submitted},on:{"click":function($event){return _vm.confirm()}}},[_vm._v("Ta bort")])
}
var staticRenderFns = []

export { render, staticRenderFns }